export default __webpack_public_path__ + "static/media/app_ui.a4c8ce09.png";